import { isWidthUp } from '@material-ui/core/withWidth'

export default makeStyles((theme) => ({
  container: {
    padding: 0,
  },
  content: {
    padding: '30px 20px',
    marginBottom: 30,
  },
  donateContainer: ({ width }) => ({
    backgroundColor: theme.palette.primary.light,
    padding: `${isWidthUp('md', width) ? '55' : '25'}px 0`,
    marginBottom: 20,
  }),
  anonymous: {
    marginBottom: -20,
    marginRight: 5,
    textAlign: 'right',
  },
  qrCode: {
    height: 200,
    width: 200,
    margin: '30px 0',
  },
  buttonContainer: ({ width }) => ({
    width: '100%',
    paddingLeft: 0,
    paddingRight: 0,
  }),
  stepper: {
    backgroundColor: 'transparent',
  },
  stepLabel: {
    marginBottom: 20,
    background: 'white',
    borderRadius: 25,
    cursor: 'pointer',
  },
}))
